export const AUTUMN_INSTAGRAM = 'https://www.instagram.com/canopy_systems_/';

export const AUTUMN_VENMO = 'https://www.venmo.com/u/aprabhu04';

export const AUTUMN_GUIDES = [
  { slug: 'sundew', file: 'sundew.pdf', image: 'sundew-plant.jpg', label: 'Sundews' },
  { slug: 'pinguicula', file: 'pinguicula.pdf', image: 'pinguicula-plant.jpg', label: 'Butterworts' },
  { slug: 'sarracenia', file: 'sarracenia.pdf', image: 'sarracenia-plant.jpg', label: 'Pitcher plants' },
  { slug: 'utricularia', file: 'utricularia.pdf', image: 'utricularia-plant.jpg', label: 'Bladderworts' },
];

export function autumnGuidePath(slug) {
  return `/autumn/${slug}`;
}

export function autumnGuideUrl(slug) {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}${autumnGuidePath(slug)}`;
}
